/** `user_account.persona = 1`: an FF-run demo account (always a tester). */
export const PersonaBadge: React.FC = () => (
  <span
    className="inline-flex items-center rounded-full bg-violet-100 px-2 py-0.5 text-xs font-semibold text-violet-800"
    title="FF-run demo persona — a test account used for dummy content and demos"
  >
    Persona
  </span>
);
